<template>
  <q-input dense :counter="props.showCounter" v-bind="{ ...defaultInputProps, ...$attrs, ...$props }" />
</template>

<script setup>
import { computed, defineProps, getCurrentInstance } from "vue";
const props = defineProps({
  required: { type: Boolean, default: false },
  editable: { type: Boolean, default: false },
  showCounter: { type: Boolean, default: false },
});
const edit = computed(
  () =>
    getCurrentInstance().parent.parent.exposed.edit.value &&
    (props.editable || getCurrentInstance().parent.parent.exposed.isNew.value)
);
const defaultInputProps = computed(() => ({
  class: ` ${edit.value ? "" : "q-mb-md"}`,
  lazyRules: "",
  rules: edit.value ? [props.required] : [],
  readonly: !edit.value,
  outlined: edit.value,
  clearable: edit.value,
  maxlength: 500
}));
</script>
